import {type ReactNode, useState} from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  type DropdownMenuContentSide,
  DropdownMenuTrigger,
} from '../dropdown-menu';
import {cn} from '../lib/cn';
import {getCustomContainer} from '../lib/utils';

export type DropdownButtonProps = {
  trigger: ReactNode | ((isOpen: boolean) => ReactNode);
  children?: ReactNode;
  side?: DropdownMenuContentSide;
  modal?: boolean;
  className?: string;
};

export function DropdownButton({
  trigger,
  children,
  side,
  modal,
  className,
}: DropdownButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu onOpenChange={setIsOpen} modal={modal}>
      <DropdownMenuTrigger asChild>
        {typeof trigger === 'function' ? trigger(isOpen) : trigger}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        container={getCustomContainer()}
        className={cn('max-w-[240px]', className)}
        align="start"
        side={side}
      >
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
